export function isHostedCheckoutEnabled(): boolean {
  return true || sessionStorage.getItem('feature_stripe_hosted') === 'enabled';
}

/**
 * The on-phone passport reader (crew papers, Phase 4). Off until real passport
 * photos meet the pass mark (docs/wip/CREW_PAPER_REQUESTS.md § Passport reads
 * itself). The build flag VITE_PASSPORT_READER=on|off overrides this default;
 * opening any page with ?passport_reader=on|off overrides both in that browser
 * (remembered), and ?passport_reader=default forgets it.
 */
export const PASSPORT_READER_DEFAULT = false;
const PASSPORT_READER_KEY = 'feature_passport_reader';

type FlagStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export function isPassportReaderEnabled(ctx: { build?: string; search?: string; storage?: FlagStorage } = {}): boolean {
  const build = 'build' in ctx ? ctx.build : import.meta.env.VITE_PASSPORT_READER;
  const search = ctx.search ?? (typeof window !== 'undefined' ? window.location.search : '');
  let storage: FlagStorage | undefined = ctx.storage;
  if (!storage) { try { storage = localStorage; } catch { storage = undefined; } }
  const asked = new URLSearchParams(search).get('passport_reader');
  if (asked === 'on' || asked === 'off') {
    try { storage?.setItem(PASSPORT_READER_KEY, asked); } catch { /* storage blocked: this page only */ }
    return asked === 'on';
  }
  if (asked === 'default') {
    try { storage?.removeItem(PASSPORT_READER_KEY); } catch { /* ignore */ }
  } else {
    let saved: string | null = null;
    try { saved = storage?.getItem(PASSPORT_READER_KEY) ?? null; } catch { /* ignore */ }
    if (saved === 'on' || saved === 'off') return saved === 'on';
  }
  if (build === 'on' || build === 'off') return build === 'on';
  return PASSPORT_READER_DEFAULT;
}
